import actions from '@/core/store/gerar-relatorio/actions'

export default {
	actions,
}
